import { createOriginFunctionAnnotation } from '../lambdas'
import {
  batchBound as originBound,
  batch as originFn
} from '../operations/register'

export const batch = createOriginFunctionAnnotation(
  'batch',
  originFn,
  originBound
)
